import {
    FeatureEditor as BaseFeatureEditor,
    FeatureEditorActions as BaseFeatureEditorActions,
    FeatureEditorReducer as BaseFeatureEditorReducer,
    Map as BaseMap,
    MapActions as BaseMapActions,
    MapReducer as BaseMapReducer
} from './base';

import {addFeatureProperties, removeFeatureProperties} from './common/utils';
import {FeatureEditor, FeatureEditorActions, FeatureEditorReducer, Map, MapActions, MapReducer} from './stateful';

export {
    BaseMap,
    BaseMapActions,
    BaseMapReducer,
    BaseFeatureEditor,
    BaseFeatureEditorActions,
    BaseFeatureEditorReducer,
    Map,
    MapReducer,
    MapActions,
    FeatureEditor,
    FeatureEditorReducer,
    FeatureEditorActions,
    addFeatureProperties,
    removeFeatureProperties,
};
